import createAsyncLocalStorage from './defaults/asyncLocalStorage';

import autoRehydrate from './autoRehydrate';
import createPersistor from './createPersistor';
import createTransform from './createTransform';
import getStoredState from './getStoredState';
import persistStore from './persistStore';
import purgeStoredState from './purgeStoredState';

var storageDeprecatedMessage = function storageDeprecatedMessage(type) {
  return '\n  To import async' + type + 'Storage please import from \'redux-persist/storages\'. For Example:\n  `import { async' + type + 'Storage } from \'redux-persist/storages\'`\n  or `var async' + type + 'Storage = require(\'redux-persist/storages\').async' + type + 'Storage`\n';
};

var storages = {
  asyncLocalStorage: createAsyncLocalStorage('local', { deprecated: storageDeprecatedMessage('Local') }),
  asyncSessionStorage: createAsyncLocalStorage('session', { deprecated: storageDeprecatedMessage('Session') })
};

export { autoRehydrate, createPersistor, createTransform, getStoredState, persistStore, purgeStoredState, storages };


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/es/index.js
// module id = 563
// module chunks = 3